.dropdown-menu {
  overflow: unset !important;
}

.toggler {
  height: 32px;
  color: var(--default--text-color--17);
}

.chevron {
  svg {
    fill: var(--default--icon--fill-color--11);
  }
}
